export const CONTAINER_ID = "steal-deal-cart"

export const STEAL_STORE_CART_ERROR_DATA_TEST_ID = "dineout-steal-store-cart-error";